import { useCallback } from 'react';

import { toast } from '@/common/components/shared/toaster/toast';
import { useUpdateEmployeeGeneralInformationMutation } from '@/common/graphql';
import type { EmployeeGeneralInformationFormDataType } from '@/common/types';
import { ApiUtils, StringUtils } from '@/common/utils';

export const useUpdateEmployeeGeneralInformation = ({ onCompleted }: { onCompleted: VoidFunction }) => {
  const [updateRecord, { loading }] = useUpdateEmployeeGeneralInformationMutation();

  const handleUpdateEmployeeGeneralInformation = useCallback(
    async (formData: EmployeeGeneralInformationFormDataType, employeeId: string) => {
      await updateRecord({
        variables: {
          input: {
            companyEmail: {
              account: formData.companyEmailAccount || '',
              domainId: formData.companyEmailDomain || '',
            },
            employeeId: employeeId,
            hiringSource: formData.hiringSource,
            isNewGraduate: formData.isNewGraduate,
            hiredDate: formData.hiredDate,
            legalFullName: formData.legalFullName || '',
            nameInLocalLanguage: formData.nameInLocalLanguage,
            japanesePhoneticName: formData.japanesePhoneticName,
            preferredFullName: formData.preferredFullName || '',
            primaryManagerId: formData.primaryManagerId || '',
            nationalityId: formData.nationalityId || '',
            needsProbationReview: formData.needsProbationReview,
            probationReviewEndDate: StringUtils.emptyToNull(formData.probationReviewEndDate),
            dottedLineManagerId: formData.dottedLineManagerId || null,
            greenhouseLink: formData.greenhouseLink || null,
          },
        },
        onError: error => ApiUtils.handleApiError(error),
        onCompleted: data => {
          if (data.updateEmployeeGeneralInformation) {
            toast.success();
            onCompleted();
          }
        },
      });
    },
    [onCompleted, updateRecord],
  );

  return {
    handleUpdateEmployeeGeneralInformation,
    loading,
  };
};
